<template>
  <aside class="sidebar" :class="{ collapsed: collapsed }">
    <div class="brand">
      <span class="brand-mark">EA</span>
      <span class="brand-text">ExAgent</span>
    </div>
    <nav class="nav-list">
      <router-link
        v-for="item in menus"
        :key="item.path"
        :to="item.path"
        class="nav-item"
        @click.native="$emit('navigate')"
      >
        <i :class="item.icon"></i>
        <span>{{ $t(item.titleKey) }}</span>
      </router-link>
    </nav>
  </aside>
</template>

<script>
export default {
  name: 'Sidebar',
  props: {
    collapsed: Boolean
  },
  data() {
    return {
      menus: [
        { path: '/dashboard', titleKey: 'menu.dashboard', icon: 'el-icon-data-analysis' },
        { path: '/users', titleKey: 'menu.users', icon: 'el-icon-user' },
        { path: '/recharges', titleKey: 'menu.recharges', icon: 'el-icon-s-finance' },
        { path: '/withdraws', titleKey: 'menu.withdraws', icon: 'el-icon-bank-card' },
        { path: '/commission', titleKey: 'menu.commission', icon: 'el-icon-coin' },
        { path: '/settlements', titleKey: 'menu.settlements', icon: 'el-icon-s-order' }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/layout/Sidebar.vue